import React, { useEffect, useRef } from 'react';
import './compiled-code.css';

export const CompiledCode = (props) => {
  const { css, html, js } = props;
  const iFrame = useRef(null);

  useEffect(() => {
    if (iFrame.current) {
      const doc = iFrame.current.contentWindow.document;
      doc.open();
      doc.writeln(
        `<html><head></head><body>${html}</body></html><style>body{width: 100%; height: 100%; margin: 0; position: relative; display:flex;justify-content:center;align-items:center;}${css}</style><script>${js}</script>`
      )
      doc.close();
    }
  }, [])

  const runCode = () => {
    if (iFrame.current) {
      const doc = iFrame.current.contentWindow.document;
      doc.open();
      doc.writeln(
        `<html><head></head><body>${html}</body></html><style>body{display:flex;justify-content:center;align-items:center;}${css}</style><script>${js}</script>`
      )
      doc.close();
    }
  }

  return (
    <div className="compiled-code">
      <iframe title="compiled-code" ref={iFrame}></iframe>
      <div className="run-code" onClick={runCode}>▶ run code</div>
    </div>
  );
}

// .square {
// width: 100px;
// height: 100px;
// background-color: blue;
// animation: spin 1s forwards infinite linear;
// }

// @keyframes spin {
//   0% {  transform: rotate(0deg) }
// 100% { transform: rotate(360deg) }
// }